import React from 'react';

// Card for `kind: "gtfs.station_info"`. Emitted by gtfs_endpoints.station_info
// after the user picks a Metro-North station. Renders the station header,
// town context, a short description, and the bulleted town facts.
//
// Expected structured shape:
//   { kind: "gtfs.station_info",
//     stop_id: "109", name: "Westport",
//     municipality: "Westport", state: "CT",
//     lat: 41.1189, lng: -73.3714,
//     description: "<2-3 sentences>",
//     facts: ["<fact>", …] }
export default function GtfsStationInfoCard({ structured }) {
  const facts = structured.facts || [];
  const town = [structured.municipality, structured.state].filter(Boolean).join(', ');
  return (
    <div style={{
      marginBottom: '10px', padding: '12px', background: '#f8f9fa',
      borderRadius: '8px', border: '1px solid #e9ecef',
    }}>
      <div style={{ fontSize: '1.15rem', fontWeight: 700, marginBottom: '4px' }}>
        {structured.name}
      </div>
      {town && (
        <div style={{ fontSize: '0.85rem', color: '#666', marginBottom: '8px' }}>
          {town}
        </div>
      )}
      {structured.description && (
        <div style={{ fontSize: '0.9rem', marginBottom: '10px', lineHeight: 1.5 }}>
          {structured.description}
        </div>
      )}
      {facts.length > 0 && (
        <>
          <div style={{ fontSize: '0.9rem', fontWeight: 700, marginBottom: '4px' }}>
            About the town
          </div>
          <ul style={{
            margin: 0, paddingLeft: '20px', fontSize: '0.9rem',
            color: '#444', lineHeight: 1.5,
          }}>
            {facts.map((f, i) => (<li key={i}>{f}</li>))}
          </ul>
        </>
      )}
    </div>
  );
}
